// Panel tokens are separate from owner and platform-super-admin sessions.
// A tab session wins over a legacy persistent token if both exist.
export function readPanelToken() {
  return sessionStorage.getItem('token') || localStorage.getItem('token');
}

export function clearPanelToken() {
  sessionStorage.removeItem('token');
  localStorage.removeItem('token');
}

export function storePanelToken(token, rememberMe = true) {
  // Never leave a previous persistent identity behind a tab-only sign-in.
  clearPanelToken();
  (rememberMe ? localStorage : sessionStorage).setItem('token', token);
}
